<template>
  <Content>
    <template #body>
      <Form
        :scheme="scheme"
        :method-fetch-data="methods.fetchData"
        :method-create-data="methods.createData"
        :method-update-data="methods.updateData"
        :method-update-scheme="methods.updateScheme"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Form from "@/components/Form";

import {
  getBannerById as fetchData,
  createBanner as createData,
  updateBanner as updateData,
} from "@/api/banners";
import { getSurfaces } from "@/api/surfaces";
import { getColors } from "@/api/colors";
import { getPartners } from "@/api/partners";
import { getRatios } from "@/api/ratios";
import defaultScheme from "@/api/schemes/banners";
import addCollectionsToScheme from "@/utils/addCollectionsToScheme";

const updateScheme = async (scheme) => {
  // Todo: utils with promise all
  try {
    const { surface, color, partner, ratio } = scheme.properties;
    // поверхности
    const surfaces = await getSurfaces();
    Object.assign(surface, {
      items: surfaces.surfaces,
      params: { key: "id", label: "name", multiple: false },
    });
    // цвета
    const colors = await getColors();
    Object.assign(color, {
      items: colors.colors,
      params: { key: "id", label: "name", multiple: false },
    });
    // партнеры
    const partners = await getPartners();
    Object.assign(partner, {
      items: partners.partners,
      params: { key: "id", label: "name", multiple: false },
    });
    // соотношение сторон (ratio)
    const ratios = await getRatios();
    Object.assign(ratio, {
      items: ratios.ratios,
      params: { key: "id", label: "name", multiple: false },
    });

    scheme = await addCollectionsToScheme(scheme);
    // console.log("scheme", scheme.properties.surface);
  } catch (err) {
    console.log(err);
  }
  return scheme;
};

const normalizeData = (data) => {
  if (data.surface) data.surface = data.surface.id;
  if (data.color) data.color = data.color.id;
  if (data.partner) data.partner = data.partner.id;
  if (data.ratio) data.ratio = data.ratio.id;
};

export default {
  components: {
    Content,
    Form,
  },
  data() {
    return {
      scheme: defaultScheme,
      methods: {
        fetchData,
        async createData(data) {
          normalizeData(data);

          return await createData(data);
        },
        async updateData(id, data) {
          normalizeData(data);

          return await updateData(id, data);
        },
        updateScheme,
      },
    };
  },
};
</script>
